// test774
(774 && 0);
